import { isEmpty, isNull } from "../../utils/is.js";
import { deepEqual } from "../../utils/deepEqual.js";
import { getCurrentTimestamp, timestampToIsoString } from "../../utils/date.js";
import { stringifyObjectValues } from "../../utils/json.js";
import { captureMetas } from "../../metas/capture.js";
import "../../transports/const.js";
import { addItemToUserActionBuffer } from "../userActions/initialize.js";
//#region src/api/events/initialize.ts
function initializeEventsAPI({ internalLogger, config, metas, transports, tracesApi, userActionsApi }) {
	let lastPayload = null;
	const pushEvent = (name, attributes, domain, { skipDedupe, spanContext, timestampOverwriteMs, customPayloadTransformer = (payload) => payload } = {}) => {
		try {
			const attrs = stringifyObjectValues(attributes);
			const payload = customPayloadTransformer({
				name,
				domain: domain !== null && domain !== void 0 ? domain : config.eventDomain,
				attributes: isEmpty(attrs) ? void 0 : attrs,
				timestamp: timestampOverwriteMs ? timestampToIsoString(timestampOverwriteMs) : getCurrentTimestamp(),
				trace: spanContext ? {
					trace_id: spanContext.traceId,
					span_id: spanContext.spanId
				} : tracesApi.getTraceContext()
			});
			const testingPayload = {
				name: payload.name,
				attributes: payload.attributes,
				domain: payload.domain
			};
			if (!skipDedupe && config.dedupe && !isNull(lastPayload) && deepEqual(testingPayload, lastPayload)) {
				internalLogger.debug("Skipping event push because it is the same as the last one\n", payload);
				return;
			}
			const previousPayload = lastPayload;
			const meta = captureMetas(metas);
			if (lastPayload !== previousPayload && !skipDedupe && config.dedupe && deepEqual(testingPayload, lastPayload)) return;
			lastPayload = testingPayload;
			const item = {
				meta,
				payload,
				type: "event"
			};
			internalLogger.debug("Pushing event\n", item);
			if (!addItemToUserActionBuffer(userActionsApi.getActiveUserAction(), item)) transports.execute(item);
		} catch (err) {
			internalLogger.error("Error pushing event", err);
		}
	};
	return { pushEvent };
}
//#endregion
export { initializeEventsAPI };

//# sourceMappingURL=initialize.js.map